import type { TenantTypography } from '@/config/tenants/types'

export const MERCY_HEADING_SCALE: NonNullable<TenantTypography['scale']> = {
    h1: { fontSize: '1.5rem', lineHeight: '120%', letterSpacing: '-0.24px' },
    h2: { fontSize: '1.25rem', lineHeight: '120%', letterSpacing: '-0.24px' },
    h3: { fontSize: '1.125rem', lineHeight: '120%', letterSpacing: '-0.24px' },
    h4: { fontSize: '1rem', lineHeight: '120%', letterSpacing: '-0.24px' },
    h5: { fontSize: '0.875rem', lineHeight: '120%', letterSpacing: '-0.24px' },
}
